import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { withRouter, Route, Link } from "react-router-dom";
import "react-sticky-header/styles.css";
import "../../../assets/css/components/Header/Header.css";
import Icon from "react-icons-kit";
import { ic_close } from "react-icons-kit/md/ic_close";

const Header = inject("profileStore", "sharedStore")(observer(class Header extends Component {
  constructor(props) {
    super(props);
    this.login = false;
    this.state = {
      collapse: false,
      isLogin: false,
      isUserLoggedIn: false,
      firstname: "",
      lastname: "",
      isHeaderShrinked: false,
      isLoginPage: false,
      isOnLoginPage: false,
      banner_notification: false,
    };
    this.onClick = this.onClick.bind(this);
    this.handleUserName = this.handleUserName.bind(this);
  }

  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }

  handleUserName() {
    return <Route exact path="/profile" />;
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        banner_notification: true,
      });
    }, 10000);
    if (window.innerWidth > 200) {
      window.addEventListener("scroll", this.changeHeaderOnScroll);
    }
    this.handleLoginPage(this.props.location.pathname);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.handleLoginPage(nextProps.location.pathname);
    }
    this.setState({
      scrolling: !nextProps.scrolling,
    });
  }

  changeHeaderOnScroll = () => {
    let shrinkHeader = 20;
    let scroll = window.pageYOffset || document.documentElement.scrollTop;
    if (scroll >= shrinkHeader) {
      this.setState({
        isHeaderShrinked: true,
      });
    } else {
      this.setState({
        isHeaderShrinked: false,
      });
    }
  };

  handleLoginPage(currentRoute) {
    if (currentRoute === "/") {
      this.setState({
        isLoginPage: true,
      });
    } else if (currentRoute === "/registration-expired") {
      this.setState({
        isLoginPage: true,
      });
    } else {
      this.setState({
        isLoginPage: false,
      });
    }
  }

  logoutApi = () => {
    return fetch("api/user/logout/", {
      method: "post",
      headers: { "Content-Type": "application/json" },
    });
  };

  logout = () => {
    console.log("im in here");
    this.setState({
      banner_notification: false,
    });

    this.logoutApi();
    this.props.sharedStore.showBanner(true);
    return false;
  };
  closeBanner = () => {
    this.props.sharedStore.showBanner(false);
    this.setState({
      banner_notification: false,
    });
  };
  render() {
    let { isHeaderShrinked, isLoginPage } = this.state;

    let { sharedStore } = this.props;
    return (
      <header className={isHeaderShrinked ? "shrink" : ""}>
        {/* Navigation menu for mobile view */}
        <nav
          className={
            "navbar navbar-default navbar-fixed-top mobile-nav " +
            (isLoginPage ? "login_page" : "")
          }
          id={isLoginPage ? "loginNav" : ""}
        >
          <div className="navbar-header">
            <div id="navbarContainer">
              {this.props.sharedStore.showLoginDropdown === true ||
              isLoginPage === false ? (
                <button
                  type="button"
                  className="navbar-toggle collapsed"
                  data-toggle="collapse"
                  data-target="#navbar"
                  aria-expanded="false"
                  aria-controls="navbar"
                >
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                </button>
              ) : (
                <div />
              )}
              <a className="navbar-brand" href="https://www.izenda.com/">
                <img
                  src="https://3u8npt2xyr3u2fgvai49zopv-wpengine.netdna-ssl.com/wp-content/uploads/2019/05/izenda-logo-white.png"
                  alt="img"
                  className="whit-logo"
                />
                <img
                  src="https://3u8npt2xyr3u2fgvai49zopv-wpengine.netdna-ssl.com/wp-content/uploads/2019/05/izenda-logo-color.png"
                  alt="img"
                  className="dark-logo"
                />
              </a>
            </div>
          </div>

          <div id="navbar" className="navbar-collapse collapse">
            <div className="container">
              <ul
                className={
                  isLoginPage ? "noLogin" : "nav navbar-nav navbar-right"
                }
              >
                {/* {(this.props.sharedStore.showLoginDropdown === false) ?
                  <HeaderMobile /> : <div></div>
                } */}
                <li className="custom-btn" id="loginCollapsed">
                  {this.props.sharedStore.showLoginDropdown === true ? (
                    <React.Fragment>
                      <a className="btn-req" href="/">
                        <span onClick={this.logout}>LOGOUT</span>
                      </a>
                      <a className="btn-req" href="/profile">
                        <span onClick={this.handleUserName}>PROFILE</span>
                      </a>
                    </React.Fragment>
                  ) : (
                    <Link to="/">LOGIN</Link>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </nav>

        {/* Navigation menu for desktop view */}
        <nav
          className={
            "navbar navbar-default navbar-fixed-top desktop-nav " +
            (isLoginPage ? "login_page" : "")
          }
          id={isLoginPage ? "loginNav" : ""}
        >
          <div id="navbarContainer">
            {/* {this.state.banner_notification ? (<div>
        
          </div>) : null} */}
            {this.props.sharedStore.showLoginDropdown ? (
              <div>
                {this.state.banner_notification &&
                sharedStore.banner_notification ? (
                  <div className="banner_notification">
                    <span
                      onClick={this.closeBanner}
                      className="close-icon-wrapper"
                    >
                      <Icon
                        size={24}
                        icon={ic_close}
                        className="cursor-pointer"
                      />
                    </span>
                    Izenda will no longer support the .NET full framework with versions 4.0.0 and higher beginning July 2021. <a href="https://izenda.atlassian.net/servicedesk/customer/portal/2/article/1910013972" target="_blank"> Learn More</a>
                  </div>
                ) : null}
              </div>
            ) : null}
            <div className="navbar-header">
              <button
                type="button"
                className="navbar-toggle collapsed"
                data-toggle="collapse"
                data-target="#navbar"
                aria-expanded="false"
                aria-controls="navbar"
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>
              <a className="navbar-brand" href="https://www.izenda.com/">
                <img
                  src="https://3u8npt2xyr3u2fgvai49zopv-wpengine.netdna-ssl.com/wp-content/uploads/2019/05/izenda-logo-white.png"
                  alt="img"
                  className="whit-logo"
                />
                <img
                  src="https://3u8npt2xyr3u2fgvai49zopv-wpengine.netdna-ssl.com/wp-content/uploads/2019/05/izenda-logo-color.png"
                  alt="img"
                  className="dark-logo"
                />
              </a>
            </div>
            <div id="navbar" className="navbar-collapse collapse">
              <ul className="nav navbar-nav navbar-right">
                {!isLoginPage && (
                  <li className="dropdown" id="loginFixed">
                    {this.props.sharedStore.showLoginDropdown === true ? (
                      <React.Fragment>
                        <button className="dropbtn loginMenu">
                          <i className="fa fa-user-circle" id="userIcon" />
                          <li
                            className="dropdown user-name-li"
                            id="displayUser"
                          >
                            {sharedStore && sharedStore.profileData
                              ? sharedStore.profileData.first_name +
                                " " +
                                this.props.sharedStore.profileData.last_name
                              : "User"}
                          </li>
                          <i
                            className="fa fa-angle-down user-dropdown-icon"
                            id="dropIcon"
                          />
                        </button>
                        <div className="dropdown-content" id="login-link">
                          <div>
                            <a href="/profile">
                              <span
                                className="logout"
                                onClick={this.handleUserName}
                              >
                                PROFILE
                              </span>
                            </a>
                            {/* <a href="/login"> */}
                            <span className="logout" onClick={this.logout}>
                              LOGOUT
                            </span>
                            {/* </a> */}
                          </div>
                        </div>
                      </React.Fragment>
                    ) : (
                      <div className="loginGetStarted">
                        <Link to="/login" className="logout">
                          LOGIN
                        </Link>
                      </div>
                    )}
                  </li>
                )}
              </ul>
            </div>
          </div>
        </nav>
      </header>
    );
  }
}));

Header.defaultProps = {
  position: "static",
  scrolling: true,
};

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/common/Header/Header.jsx